

import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'ri-dashboard-line',
        link: '/dashboard'
    },

    {
        id: 3,
        label: 'E-Sign',
        icon: 'ri-quill-pen-line',
        subItems: [
            {
                id: 31,
                label: 'Documents',
                icon: 'ri-file-text-line',
                link: '/esign/documents',
                parentId: 3
            },
            {
                id: 32,
                label: 'Customers',
                icon: 'ri-user-3-line',
                link: '/esign/customers',
                parentId: 3
            },
            {
                id: 33,
                label: 'Document Templates',
                icon: 'ri-file-copy-line',
                link: '/esign/document-template',
                parentId: 3
            },
            {
                id: 34,
                label: 'Orders',
                icon: 'ri-shopping-cart-2-line',
                link: '/esign/orders',
                parentId: 3
            }
        ]
    },

    {
        id: 4,
        label: 'E-Stamp',
        icon: 'ri-government-line',
        subItems: [
            {
                id: 41,
                label: 'States',
                icon: 'ri-map-pin-2-line',
                link: '/estamp/state',
                parentId: 4
            },
            {
                id: 42,
                label: 'Users',
                icon: 'ri-user-settings-line',
                link: '/estamp/role',
                parentId: 4
            },
            {
                id: 43,
                label: 'Customers',
                icon: 'ri-user-3-line',
                link: '/estamp/customer',
                parentId: 4
            },
            {
                id: 44,
                label: 'Customer Orders',
                icon: 'ri-shopping-bag-line',
                link: '/estamp/client-order',
                parentId: 4
            },
            {
                id: 45,
                label: 'Inventory',
                icon: 'ri-archive-line',
                link: '/estamp/inventory',
                parentId: 4
            },

        ]
    },

    {
        id: 5,
        label: 'Plans',
        icon: 'ri-task-line',
        link: '/plans'
    },
    {
        id: 6,
        label: 'Analytics',
        icon: 'ri-bar-chart-box-line',
        link: '/analytics'
    },
    {
        id: 7,
        label: 'Notification Template',
        icon: 'ri-notification-3-line',
        link: '/email-settings'
    },
    {
        id: 8,
        label: 'Cron Job',
        icon: 'ri-time-line',
        link: '/cron-job'
    },
    {
        id: 9,
        label: 'Settings',
        icon: 'ri-settings-3-line',
        link: '/settings'
    }
];


// import { MenuItem } from './menu.model';

// export const MENU: MenuItem[] = [
//     {
//         id: 1,
//         label: 'MENUITEMS.MENU.TEXT',
//         isTitle: true
//     },
//     {
//         id: 2,
//         label: 'MENUITEMS.DASHBOARDS.TEXT',
//         icon: 'ri-dashboard-line',
//         // badge: {
//         //     variant: 'success',
//         //     text: 'MENUITEMS.DASHBOARDS.BADGE',
//         // },
//         link: '/'
//     },
//     {
//         id: 3,
//         label: 'Documents',
//         icon: 'ri-file-text-line',
//         link: '/documents'
//     },
//     {
//         id: 4,
//         label: 'Customers',
//         icon: 'ri-user-3-line',
//         link: '/customers'
//     },
//     // {
//     //     id: 5,
//     //     label: 'Vendors',
//     //     icon: 'ri-building-line',
//     //     link: '/vendors'
//     // },
//     {
//         id: 6,
//         label: 'Plans',
//         icon: 'ri-task-line',
//         link: '/plans'
//     },
//     {
//         id: 7,
//         label: 'Analytics',
//         icon: 'ri-bar-chart-box-line',
//         link: '/analytics'
//     },
//     {
//         id: 8,
//         label: 'Settings',
//         icon: 'ri-settings-3-line',
//         link: '/settings'
//     },
//     {
//         id: 9,
//         label: 'Notification Template',
//         icon: 'ri-notification-3-line',
//         link: '/email-settings'
//     },
//     {
//         id: 10,
//         label: 'Document Template',
//         icon: 'ri-file-copy-line',
//         link: '/document-template'
//     },
//     {
//         id: 11,
//         label: 'Orders',
//         icon: 'ri-shopping-cart-2-line',
//         link: '/orders'
//     },
//     {
//         id: 12,
//         label: 'Cron Job',
//         icon: 'ri-time-line',
//         link: '/cron-job'
//     },
//     {
//         id: 13,
//         label: 'State',
//         icon: 'ri-map-pin-2-line',
//         link: '/state'
//     }
// ];